import { render, staticRenderFns } from "./PcMiddle.vue?vue&type=template&id=dd6a1cde&scoped=true&"
import script from "./PcMiddle.vue?vue&type=script&lang=js&"
export * from "./PcMiddle.vue?vue&type=script&lang=js&"
import style0 from "./PcMiddle.vue?vue&type=style&index=0&id=dd6a1cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a1cde",
  null
  
)

export default component.exports